<div style="display: flex; flex-direction: row;" >
    <div style="font-size: 10px; display: flex; align-items: flex-end; margin-right: 5px;    line-height: 8px;    " *ngIf="lastAction && lastAction.atUnix && user.uid !== '0l7u6A6afVTgngfcK0k9Dllprxt2' || authService.getUid() === '0l7u6A6afVTgngfcK0k9Dllprxt2'">
        Aktiv: {{lastAction.atUnix | date: 'dd.MM.yyyy - HH:mm'}}
    </div>
    <div [matTooltip]="statusInfo" (click)="setStatus()" style="display: flex; justify-content: center; align-items: center; width: 30px; height: 20px;" [class.myStatus]="user.uid === authService.getUid()">
        <mat-icon *ngIf="lastStatus && lastStatus.status">{{lastStatus.status}}</mat-icon>
        <mat-icon *ngIf="!lastStatus?.status">help</mat-icon>
    </div>
    <div [style.background-color]="statusColor"
        style="display: flex; justify-content: center; align-items: center; width: 20px; height: 20px; border-radius: 15px; padding: 5px; font-size: 11px;"
        [matTooltip]="authService.getUid() === '0l7u6A6afVTgngfcK0k9Dllprxt2' ? lastAction.action + ':' + lastAction.addInfo: ''">
        {{user.shortName}}
    </div>
</div>